import { VmsAccount, VmsClient } from 'wisestep-api';

export const configureVmsPayload: VmsAccount = {
  id: '',
  accountName: '',
  forwardTo: '',
  loginUrl: '',
  subscription: '',
  vms: '',
  accountClient: [],
  accountPassword: '',
  otp: '',
  whiteListEmail: '',
  workspaceId: '',
  workspaceName: '',
  isActive: true,
  isVerified: false,
  isPaused: false,
  notificationEmailList: '',
  userName: '',
  frequency: '',
  organisationKey: '',
  accountManagers: [],
};

export const configureVmsClientPayload: VmsClient = {
  id: '',
  jobOwner: '',
  clientName: '',
  team: '',
  accountId: '',
  fetchOlderJobs: false,
  fetchJobsSince: 30,
  showPayRates: false,
};
